import { Spinner } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import UiNotice from '../components/UiNotice';
import { FetchStatus } from '../util/ApiUtil';
import useStores from '../stores/UseStores';

const LoginReturn = observer((): React.JSX.Element => {
  const { loginReturnStore } = useStores();

  React.useEffect(() => {
    loginReturnStore.loadLoginReturnData();
  }, []);

  if (loginReturnStore.status === FetchStatus.ERROR) {
    return <UiNotice />;
  }
  return <Spinner />;
});

export default LoginReturn;
